import {InvertedBackgroundWave} from "@commons/uinew/domaincomponent/svg";
import React from "react";

export let WaveBackgroundBottom = ({children}) => {
    return <div className={"position-relative pb-6"}>
        {children}
        <InvertedBackgroundWave/>
    </div>
}